module.exports = __webpack_public_path__ + "img/shopBanner.f9fb818d.jpg";